import type { Dictionary } from '@ngrx/entity';
import type { Uuid } from '@common/types';
import type { WebLegacyWidgetEntity } from '@web/types';
import type { WidgetState } from './widgets.reducer';
import type { PageStructureState } from '../page-structure-feature.reducer';

import { createSelector } from '@ngrx/store';

import { WIDGETS_FEATURE_KEY, widgetsAdapter } from './widgets.reducer';
import { pageStructureState } from '../page-structure-state.selectors';

const { selectAll, selectEntities, selectIds } = widgetsAdapter.getSelectors();

// Lookup the 'Widgets' feature state managed by NgRx
export const selectWidgetsState = createSelector(
    pageStructureState,
    (state: PageStructureState): WidgetState => state[WIDGETS_FEATURE_KEY]
);

export const selectAllWidgets = createSelector(selectWidgetsState, (state: WidgetState) => selectAll(state));

export const selectWidgetsEntities = createSelector(selectWidgetsState, (state: WidgetState) => selectEntities(state));

export const selectWidgetById = (id: Uuid) =>
    createSelector(
        selectWidgetsEntities,
        (entities: Dictionary<WebLegacyWidgetEntity>): WebLegacyWidgetEntity | undefined => entities[id]
    );

export const selectWidgetsIds = createSelector(selectWidgetsState, (state: WidgetState) => selectIds(state));
